import { FC } from "react";

interface LogoFullProps {
  width?: number;
  height?: number;
  style?: React.CSSProperties;
}

const LogoFull: FC<LogoFullProps> = ({ width = 91, height = 34, style }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 91 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
  >
    <rect width="91" height="33" rx="8" fill="#FFFFFFCC" />
    <path
      d="M9.90039 13.5957L14.644 22.744C14.9279 23.2916 15.7151 23.2799 15.9827 22.7242L20.3779 13.5957"
      stroke="url(#paint0_linear_1247_45491)"
      stroke-width="4.49034"
      stroke-linecap="round"
    />
    <path
      d="M22.248 23.3248L27.861 11.3506"
      stroke="url(#paint1_linear_1247_45491)"
      stroke-width="4.49034"
      stroke-linecap="round"
    />
    <path
      d="M30.3256 5.46243C30.5526 5.31245 30.8586 5.44704 30.9015 5.71565L32.3187 14.5989C32.3654 14.8914 32.0697 15.1196 31.7986 15.0004L22.8766 11.0769C22.6054 10.9577 22.5737 10.5855 22.8209 10.4222L30.3256 5.46243Z"
      fill="#20CBFF"
    />
    <path
      d="M39.4769 21.5H37.3675L41.2081 10.5909H43.6477L47.4936 21.5H45.3842L42.4705 12.8281H42.3853L39.4769 21.5ZM39.5462 17.2227H45.299V18.81H39.5462V17.2227ZM48.6953 21.5V13.3182H50.5649V14.6818H50.6502C50.7993 14.2095 51.055 13.8455 51.4172 13.5898C51.783 13.3306 52.2002 13.201 52.669 13.201C52.7755 13.201 52.8945 13.2063 53.0259 13.217C53.1608 13.2241 53.2727 13.2365 53.3615 13.2543V15.0281C53.2798 14.9996 53.1502 14.9748 52.9726 14.9535C52.7986 14.9286 52.6299 14.9162 52.4666 14.9162C52.115 14.9162 51.799 14.9925 51.5184 15.1452C51.2414 15.2944 51.023 15.5021 50.8632 15.7685C50.7034 16.0348 50.6235 16.342 50.6235 16.69V21.5H48.6953ZM59.0176 13.3182V14.8097H54.3141V13.3182H59.0176ZM55.4753 11.358H57.4036V19.0391C57.4036 19.2983 57.4426 19.4972 57.5208 19.6357C57.6024 19.7706 57.709 19.8629 57.8404 19.9126C57.9718 19.9624 58.1173 19.9872 58.2771 19.9872C58.3979 19.9872 58.508 19.9783 58.6074 19.9606C58.7104 19.9428 58.7885 19.9268 58.8418 19.9126L59.1667 21.4201C59.0637 21.4556 58.9164 21.4947 58.7246 21.5373C58.5364 21.5799 58.3056 21.6048 58.0321 21.6119C57.5492 21.6261 57.1142 21.5533 56.7271 21.3935C56.34 21.2301 56.0328 20.978 55.8056 20.6371C55.5818 20.2962 55.4718 19.87 55.4753 19.3587V11.358ZM60.4802 21.5V13.3182H62.4085V21.5H60.4802ZM61.4497 12.157C61.1443 12.157 60.8815 12.0558 60.6613 11.8533C60.4412 11.6474 60.3311 11.4006 60.3311 11.1129C60.3311 10.8217 60.4412 10.5749 60.6613 10.3725C60.8815 10.1665 61.1443 10.0636 61.4497 10.0636C61.7586 10.0636 62.0214 10.1665 62.238 10.3725C62.4582 10.5749 62.5683 10.8217 62.5683 11.1129C62.5683 11.4006 62.4582 11.6474 62.238 11.8533C62.0214 12.0558 61.7586 12.157 61.4497 12.157ZM67.8102 21.6598C66.9935 21.6598 66.2921 21.4805 65.7062 21.1218C65.1238 20.7631 64.6746 20.2678 64.3585 19.6357C64.046 19 63.8898 18.2685 63.8898 17.4411C63.8898 16.6101 64.0496 15.8768 64.3692 15.2411C64.6888 14.6019 65.1398 14.1048 65.7222 13.7496C66.3081 13.391 67.0006 13.2116 67.7996 13.2116C68.4637 13.2116 69.0514 13.3342 69.5627 13.5792C70.0776 13.8207 70.4878 14.1634 70.7932 14.6072C71.0986 15.0476 71.2726 15.5625 71.3152 16.152H69.4722C69.3976 15.7578 69.22 15.4293 68.9395 15.1665C68.6625 14.9002 68.2914 14.767 67.8262 14.767C67.432 14.767 67.0858 14.8736 66.7875 15.0866C66.4892 15.2962 66.2566 15.598 66.0897 15.9922C65.9264 16.3864 65.8447 16.8587 65.8447 17.4091C65.8447 17.9666 65.9264 18.446 66.0897 18.8473C66.2531 19.245 66.4821 19.5522 66.7769 19.7688C67.0752 19.9819 67.4249 20.0884 67.8262 20.0884C68.1103 20.0884 68.3642 20.0352 68.5879 19.9286C68.8152 19.8185 69.0052 19.6605 69.1579 19.4545C69.3106 19.2486 69.4154 18.9982 69.4722 18.7035H71.3152C71.2691 19.2823 71.0986 19.7955 70.8039 20.2429C70.5091 20.6868 70.1078 21.0348 69.6 21.2869C69.0922 21.5355 68.4956 21.6598 67.8102 21.6598ZM74.6768 10.5909V21.5H72.7486V10.5909H74.6768ZM80.1319 21.6598C79.3116 21.6598 78.6031 21.4893 78.0065 21.1484C77.4135 20.804 76.9572 20.3175 76.6376 19.6889C76.3179 19.0568 76.1581 18.3129 76.1581 17.457C76.1581 16.6154 76.3179 15.8768 76.6376 15.2411C76.9607 14.6019 77.4117 14.1048 77.9905 13.7496C78.5694 13.391 79.2494 13.2116 80.0307 13.2116C80.5349 13.2116 81.0108 13.2933 81.4582 13.4567C81.9092 13.6165 82.3069 13.8651 82.6514 14.2024C82.9994 14.5398 83.2729 14.9695 83.4717 15.4915C83.6706 16.0099 83.77 16.6278 83.77 17.3452V17.9364H77.0637V16.6367H81.9216C81.9181 16.2674 81.8382 15.9389 81.6819 15.6513C81.5257 15.3601 81.3073 15.131 81.0268 14.9641C80.7498 14.7972 80.4266 14.7138 80.0573 14.7138C79.6631 14.7138 79.3169 14.8097 79.0186 15.0014C78.7203 15.1896 78.4877 15.4382 78.3208 15.7472C78.1574 16.0526 78.074 16.3881 78.0704 16.7539V17.8885C78.0704 18.3643 78.1574 18.7727 78.3314 19.1136C78.5054 19.451 78.7487 19.7102 79.0612 19.8913C79.3737 20.0689 79.7395 20.1577 80.1585 20.1577C80.439 20.1577 80.6929 20.1186 80.9202 20.0405C81.1475 19.9588 81.3446 19.8398 81.5115 19.6836C81.6784 19.5273 81.8045 19.3338 81.8897 19.103L83.6901 19.3054C83.5765 19.7812 83.3599 20.1967 83.0403 20.5518C82.7242 20.9034 82.3194 21.1768 81.8258 21.3722C81.3322 21.5639 80.7675 21.6598 80.1319 21.6598Z"
      fill="url(#paint2_linear_1247_45491)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1247_45491"
        x1="15.1391"
        y1="13.5957"
        x2="15.1391"
        y2="24.0732"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#284EA0" />
        <stop offset="1" stop-color="#2399D6" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1247_45491"
        x1="25.0545"
        y1="11.3506"
        x2="25.0545"
        y2="23.3248"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#284EA0" />
        <stop offset="1" stop-color="#2399D6" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_1247_45491"
        x1="61"
        y1="4.5"
        x2="61"
        y2="28.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#284EA0" />
        <stop offset="1" stop-color="#2399D6" />
      </linearGradient>
    </defs>
  </svg>
);

export default LogoFull;
